/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetSkuHistoryResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetSkuHistoryResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/sku/{sku}/history
 */
export interface HistoryRequestBuilder extends BaseRequestBuilder<HistoryRequestBuilder> {
    /**
     * Returns what one SKU actually sold, month by month, as the actuals half of a history-and-forecast chart — pair it with GET /api/forecasting/sku/{sku} for the projection. This reads recorded orders, so unlike the forecast endpoints it needs no trained model. The window ends at the present and runs back 'months' months, clamped to 1–60 and defaulting to 48; months with no sales are absent from the series rather than returned as zero, so a client drawing a chart should not assume evenly spaced points. A SKU with no sales in the window returns 404 — which is also what an unknown SKU returns, since the two are indistinguishable here.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetSkuHistoryResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : Promise<GetSkuHistoryResponse | undefined>;
    /**
     * Returns what one SKU actually sold, month by month, as the actuals half of a history-and-forecast chart — pair it with GET /api/forecasting/sku/{sku} for the projection. This reads recorded orders, so unlike the forecast endpoints it needs no trained model. The window ends at the present and runs back 'months' months, clamped to 1–60 and defaulting to 48; months with no sales are absent from the series rather than returned as zero, so a client drawing a chart should not assume evenly spaced points. A SKU with no sales in the window returns 404 — which is also what an unknown SKU returns, since the two are indistinguishable here.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns what one SKU actually sold, month by month, as the actuals half of a history-and-forecast chart — pair it with GET /api/forecasting/sku/{sku} for the projection. This reads recorded orders, so unlike the forecast endpoints it needs no trained model. The window ends at the present and runs back 'months' months, clamped to 1–60 and defaulting to 48; months with no sales are absent from the series rather than returned as zero, so a client drawing a chart should not assume evenly spaced points. A SKU with no sales in the window returns 404 — which is also what an unknown SKU returns, since the two are indistinguishable here.
 */
export interface HistoryRequestBuilderGetQueryParameters {
    /**
     * How many months of history to return (1 – 60). Defaults to 48.The dashboard's combined history + forecast chart uses 48 months (4 years).
     */
    months?: number;
}
/**
 * Uri template for the request builder.
 */
export const HistoryRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/sku/{sku}/history?months={months}";
/**
 * Metadata for all the requests in the request builder.
 */
export const HistoryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: HistoryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetSkuHistoryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
